
import PIXI from '../GameEngine/pixi.js';
export default class ScoreBoard extends PIXI.Sprite {
    constructor(...arg) {
        super(...arg);
        this.player1Score = 0;
        this.player2Score = 0;

        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 50,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });

        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(2, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 180, 100);
        graphics.drawRoundedRect(0, 0, 180, 100, 10);
        // graphics.alpha = 0.5;
        this.addChild(graphics);

        //textPlayer1Points
        this.textPlayer1Points = new PIXI.Text('player1: 0', style);
        this.textPlayer1Points.x = 20;
        this.textPlayer1Points.y = 10;
        this.textPlayer1Points.scale.set(0.5);
        this.addChild(this.textPlayer1Points);

        //textPlayer2Points
        this.textPlayer2Points = new PIXI.Text('player2: 0', style);
        this.textPlayer2Points.x = 20;
        this.textPlayer2Points.y = 50;
        this.textPlayer2Points.scale.set(0.5);
        //this.textPlayer2Points.anchor.set(0.5, 0);
        this.addChild(this.textPlayer2Points);


    }
    updateScore(player1Score, player2Score) {
        if (player1Score) this.player1Score = player1Score;
        if (player2Score) this.player2Score = player2Score;

        this.textPlayer1Points.text = "player1: " + player1Score || 0;
        this.textPlayer2Points.text = "player2: " + player2Score || 0;
    }

}